/**
 * Cookie 工具函数
 */
const CookieUtil = {
  set: function (name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      // 如果 days 为 0，设置为当天的 23:59:59
      if (days === 0) {
        date.setHours(23, 59, 59, 999);
      } else {
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      }
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },

  get: function (name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  erase: function (name) {
    document.cookie = name + "=; Max-Age=-99999999;";
  },
};

/**
 * youtube player
 */
class YouTubePlayer {
  constructor(playerElement, videoId, options = {}) {
    this.youtubeUrl = "https://www.youtube.com/iframe_api";
    this.playerElement = playerElement;
    this.videoId = videoId;
    this.options = options;
    this.player = null;

    this.initPlayer();
  }

  /**
   * 初始化YouTube的script
   * @param callback
   */
  initPlayer() {
    this.initYouTubeScript(
      function () {
        if (typeof TY == "undefined" || typeof YT.Player === "undefined") {
          if (!window.youtubeIframeAPIReady) {
            window.youtubeIframeAPIReady = new Promise((resolve) => {
              window.onYouTubeIframeAPIReady = () => {
                resolve();
              };
            });
          }
          window.youtubeIframeAPIReady.then(() => {
            this.createPlayer();
          });
        } else {
          this.createPlayer();
        }
      }.bind(this)
    );
  }

  createPlayer() {
    this.player = new YT.Player(this.playerElement, {
      height: this.options.height || "360",
      width: this.options.width || "640",
      suggestedQuality: this.options.suggestedQuality || "default",
      videoId: this.videoId,
      events: {
        onReady: this.onPlayerReady.bind(this),
        onStateChange: this.onPlayerStateChange.bind(this),
      },
    });
  }

  /**
   * Initialize YouTube script
   * @param {Function} func
   */
  initYouTubeScript(func) {
    if (window.youtubeScriptLoaded) {
      func();
      return;
    }
    const scripts = document.getElementsByTagName("script");
    let isLoaded = false;
    Array.from(scripts).forEach((script) => {
      if (script.src.includes(this.youtubeUrl)) {
        isLoaded = true;
      }
    });

    if (!isLoaded) {
      const youtubeScript = document.createElement("script");
      youtubeScript.src = this.youtubeUrl;
      document.getElementsByTagName("head")[0].appendChild(youtubeScript);
      window.youtubeScriptLoaded = true;
      func();
    }
  }

  onPlayerReady(event) {
    if (this.options.onReady) {
      this.options.onReady(event);
    }
  }

  onPlayerStateChange(event) {
    if (this.options.onStateChange) {
      this.options.onStateChange(event);
    }
  }

  play() {
    if (this.player) {
      this.player.playVideo();
    }
  }

  pause() {
    if (this.player) {
      this.player.pauseVideo();
    }
  }

  stop() {
    if (this.player) {
      this.player.stopVideo();
    }
  }

  seekTo(seconds, allowSeekAhead = true) {
    if (this.player) {
      this.player.seekTo(seconds, allowSeekAhead);
    }
  }

  loadVideoById(videoId) {
    if (this.player) {
      this.videoId = videoId;
      this.player.loadVideoById(videoId);
      this.stop();
    }
  }
}

/**
 * 工具函数类
 */
class WeUtil {
  /**
   * 获取滚动条宽度
   * @returns
   */
  getScrollbarWidth() {
    const container = document.createElement("div");
    document.body.appendChild(container);
    container.style.overflow = "scroll";
    const inner = document.createElement("div");
    container.appendChild(inner);
    const scrollbarWidth = container.offsetWidth - inner.offsetWidth;
    document.body.removeChild(container);
    return scrollbarWidth;
  }

  /**
   * 禁止页面滚动
   */
  disableScroll() {
    const scrollbarWidth = this.getScrollbarWidth();
    document.documentElement.style.setProperty(
      "--scrollbar-width",
      scrollbarWidth + "px"
    );
    document.body.classList.add("no-scroll");
  }

  /**
   * 启用页面滚动
   */
  enableScroll() {
    document.body.classList.remove("no-scroll");
    document.documentElement.style.setProperty("--scrollbar-width", "17px");
  }

  /**
   * 全局 Toast（白底成功样式：左侧绿勾 + title / msg）
   * @param {string} title
   * @param {string} [msg='']
   * @param {number} [duration=3200]
   */
  toast(title, msg = "", duration = 3200) {
    if (!title) return;
    if (!this._toastEl) {
      this._toastEl = document.createElement("div");
      this._toastEl.className = "we-toast";
      this._toastEl.setAttribute("role", "status");
      this._toastEl.innerHTML =
        '<span class="we-toast__icon" aria-hidden="true">' +
        '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M15.9996 30.2804C23.8873 30.2804 30.2817 23.886 30.2817 15.9983C30.2817 8.1105 23.8873 1.71615 15.9996 1.71615C8.1118 1.71615 1.71745 8.1105 1.71745 15.9983C1.71745 23.886 8.1118 30.2804 15.9996 30.2804Z" fill="#00C800"/>' +
        '<path d="M8.85807 16.7155L13.1428 21L23.1403 11.0026" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg></span>" +
        '<span class="we-toast__text"><span class="we-toast__title"></span><span class="we-toast__msg"></span></span>';
      if (!document.getElementById("we-toast-style")) {
        const style = document.createElement("style");
        style.id = "we-toast-style";
        style.textContent =
          ".we-toast{position:fixed;left:50%;top:24px;transform:translateX(-50%) translateY(-12px);z-index:2147483647;display:flex;align-items:center;gap:8px;box-sizing:border-box;max-width:min(92vw,460px);padding:12px 14px;border-radius:10px;background:#fff;box-shadow:0 8px 28px rgba(0,0,0,.18);opacity:0;pointer-events:none;transition:opacity .25s ease,transform .25s ease}" +
          ".we-toast.is-show{opacity:1;transform:translateX(-50%) translateY(0)}" +
          ".we-toast__icon{flex:0 0 32px;width:32px;height:32px;line-height:0}" +
          ".we-toast__icon svg{display:block;width:32px;height:32px}" +
          ".we-toast__text{display:flex;flex-direction:column;align-items:flex-start;gap:4px;min-width:0}" +
          ".we-toast__title{color:#00c800;font-size:16px;font-weight:700;line-height:normal}" +
          ".we-toast__msg{color:#999;font-size:12px;font-weight:400;line-height:normal}" +
          ".we-toast__msg:empty{display:none}";
        document.head.appendChild(style);
      }
      document.body.appendChild(this._toastEl);
    }
    this._toastEl.querySelector(".we-toast__title").textContent = title;
    this._toastEl.querySelector(".we-toast__msg").textContent = msg || "";
    // Sit below sticky header when present
    let top = 24;
    document
      .querySelectorAll(
        "header.shopify-section, .shopify-section-group-header-group, .shopify-section-navigation"
      )
      .forEach((el) => {
        const s = getComputedStyle(el);
        if (s.position !== "sticky" && s.position !== "fixed") return;
        if (s.display === "none" || s.visibility === "hidden") return;
        const r = el.getBoundingClientRect();
        if (r.height > 0 && r.top <= 120 && r.bottom > top) top = r.bottom + 12;
      });
    this._toastEl.style.top = Math.round(top) + "px";
    if (this._toastTimer) clearTimeout(this._toastTimer);
    if (this._toastShowTimer) clearTimeout(this._toastShowTimer);
    this._toastEl.classList.remove("is-show");
    this._toastShowTimer = setTimeout(() => {
      this._toastEl.classList.add("is-show");
      this._toastShowTimer = null;
    }, 20);
    this._toastTimer = setTimeout(() => {
      this._toastEl.classList.remove("is-show");
      this._toastTimer = null;
    }, duration);
  }

  /**
   * 防抖函数
   * @param {*} func
   * @param {*} waity
   * @returns
   */
  debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  /**
   * 节流函数
   * @param {*} func
   * @param {*} delay
   * @returns
   */
  throttle(func, delay) {
    let lastTime = 0;
    return function (...args) {
      let nowTime = Date.now();
      if (nowTime - lastTime > delay) {
        func.apply(this, args);
        lastTime = nowTime;
      }
    };
  }
  isInViewport(el) {
    const rect = el.getBoundingClientRect();
    const isInViewport =
      rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.right > 0;
    return isInViewport;
  }
  getDistanceFromTop(element) {
    var distance = element.offsetTop;
    var parent = element.offsetParent;
    while (parent) {
      distance += parent.offsetTop;
      parent = parent.offsetParent;
    }
    return distance;
  }

  /**
   * 容器自动滚动
   * @param {*} container
   * @param {*} target
   */
  containerAutoScoll(container, target) {
     const containerWidth = container.offsetWidth;
    const containerScrollWidth = container.scrollWidth;
    const tabLeft = target.offsetLeft;
    const tabWidth = target.offsetWidth;
    const scrollPosition = tabLeft + tabWidth / 2 - containerWidth / 2;
    // 平滑滚动
    container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
    });
    // 计算滚动后的边界情况
    const maxScrollLeft = containerScrollWidth - containerWidth;
    const isAtStart = scrollPosition <= 0;
    const isAtEnd = scrollPosition >= maxScrollLeft;
    return {
        isAtStart,
        isAtEnd
    };
  }

  /**
   * 倒计时
   * @param {*} expiry
   * @returns
   */
  timer(expiry) {
    return {
      expiry: expiry,
      remaining: null,
      init() {
        this.setRemaining();
        setInterval(() => {
          this.setRemaining();
        }, 1000);
      },
      setRemaining() {
        const diff = this.expiry - new Date().getTime();
        if (diff > 0) {
          this.remaining = parseInt(diff / 1000);
        } else {
          this.remaining = 0;
        }
      },
      days() {
        return {
          value: this.remaining / 86400,
          remaining: this.remaining % 86400,
        };
      },
      hours() {
        return {
          value: this.days().remaining / 3600,
          remaining: this.days().remaining % 3600,
        };
      },
      minutes() {
        return {
          value: this.hours().remaining / 60,
          remaining: this.hours().remaining % 60,
        };
      },
      seconds() {
        return {
          value: this.minutes().remaining,
        };
      },
      format(value) {
        return ("0" + parseInt(value)).slice(-2);
      },
      time() {
        return {
          days: this.format(this.days().value),
          hours: this.format(this.hours().value),
          minutes: this.format(this.minutes().value),
          seconds: this.format(this.seconds().value),
        };
      },
    };
  }

  timerTz(expiry, timeZone) {
    const deadlineUTC = new Date(expiry).getTime();
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      format(value) {
        return value < 0 ? "00" : value < 10 ? `0${value}` : value;
      },
      getDeadlineUTC(deadline, timeZone) {
        const dtf = new Intl.DateTimeFormat('en-US', {
          timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        });

        const parts = dtf.formatToParts(new Date(deadline));
        const map = {};
        for (const p of parts) map[p.type] = p.value;
        const localStr = `${map.year}-${map.month}-${map.day}T${map.hour}:${map.minute}:${map.second}`;
        return new Date(localStr).getTime();
      },
      updateCountdown() {
        // 获取当前UTC时间
        const nowUTC = this.getDeadlineUTC(new Date(),timeZone);
        let diff = Math.max(0,deadlineUTC - nowUTC);
        this.days = Math.floor(diff / (1000 * 60 * 60 * 24));
        diff %= 1000 * 60 * 60 * 24;

        this.hours = Math.floor(diff / (1000 * 60 * 60));
        diff %= 1000 * 60 * 60;

        this.minutes = Math.floor(diff / (1000 * 60));
        diff %= 1000 * 60;
        
        this.seconds = Math.floor(diff / 1000);
      },
      init() {
        this.updateCountdown();
        setInterval(() => {
          this.updateCountdown();
        }, 1000);
      },
      time() {
        return {
          days: this.format(this.days),
          hours: this.format(this.hours),
          minutes: this.format(this.minutes),
          seconds: this.format(this.seconds),
        };
      },
    };
  }
}

const weUtil = new WeUtil();
window.weUtil = weUtil;
